import React, { Component } from "react";
import "../Register/register.css";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
// import StepLabel from '@material-ui/core/StepLabel';
import StepConnector from "@material-ui/core/StepConnector";
import StepButton from "@material-ui/core/StepButton";
// import Button from '@material-ui/core/Button';
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";
import { Form, FormGroup, Label, Input, Button, Row, Col } from "reactstrap";
import axios from "axios";
import conf from "../../conf.json";
import { Checkbox, FormControlLabel } from "@material-ui/core";

const styles = theme => ({
  root: {
    width: "90%"
  },
  button: {
    marginRight: theme.spacing.unit
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit
  },
  connectorActive: {
    "& $connectorLine": {
      borderColor: theme.palette.secondary.main
    }
  },
  connectorCompleted: {
    "& $connectorLine": {
      borderColor: theme.palette.primary.main
    }
  },
  connectorDisabled: {
    "& $connectorLine": {
      borderColor: theme.palette.grey[100]
    }
  },
  connectorLine: {
    transition: theme.transitions.create("border-color")
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120
  }
});

function getSteps() {
  return ["ข้อมูลบริษัท", "ข้อมูลผู้ติดต่อ", "ข้อมูลฝ่ายขาย", "ข้อมูลทางบัญชี"];
}

class AddCustomer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "1",
      activeStep: 0,
      position: "t",
      openSelect: false,
      openSelectPosiition: false,
      open: false,
      sale_name: "",
      callcentername: "",
      callcenter: [],
      tmp_callcenter: [],
      Loading: false,
      sales: [],
      selectsale: "",
      selectCallcenter: "",
      salesData: [],
      tel: "",
      emailSale: "",
      taxid: "",
      tmp_contact: {
        company_thname: "",
        company_enname: "",
        company_id: "",
        account_no: "",
        group_thname: "",
        group_enname: "",
        parent_account: "",
        address_no: "",
        moo: "",
        soi: "",
        vilage: "",
        road: "",
        subdistrict: "",
        district: "",
        province: "",
        zipcode: "",
        telephone1: "",
        telephone2: "",
        contact_name: "",
        contact_no: "",
        contact_email: "",
        contact_name_2: "",
        contact_no_2: "",
        contact_email_2: "",
        type: "",
        status: "0",
        grade: "",
        financial_grade: "",
        financial_code: "",
        customer_product: "",
        billing_name: "",
        billing_place: "",
        cheque_receive_date: "",
        call_center_name: "",
        call_center_noted: "",
        sale_name: "",
        financial_contact_name: "",
        financial_contact_phone: "",
        financial_contact_email: "",
        tax_id: "",
        type_2: "",
        customer_product_2: "",
        sale_phone: "",
        sale_email: "",
        sale_noted: "",
        bill_create_date: ""
      }
    };

    this.getSales = this.getSales.bind(this);
    this.getSales();

    this.getCallCenters = this.getCallCenters.bind(this);
    this.getCallCenters();

    this.handleInput = this.handleInput.bind(this);
    this.getStepContent = this.getStepContent.bind(this);

    this.handleChangeInputSec = this.handleChangeInputSec.bind(this);

    this.addCus = this.addCus.bind(this);

    this.handleChangeStatus = this.handleChangeStatus.bind(this);
  }
  handleChangeStatus = event => {
    if (event.target.value !== this.state.tmp_contact.status) {
      var tmp_contact = this.state.tmp_contact;
      tmp_contact.status = event.target.value;
      this.setState({ tmp_contact: tmp_contact });
    }
  };

  handleChangeInputSec = event => {
    let tmp_contact = this.state.tmp_contact;
    tmp_contact[event.target.name] = event.target.value;
    this.setState({ tmp_contact: tmp_contact });
  };
  getStepContent(stepIndex, state, classes) {
    switch (stepIndex) {
      case 0:
        return (
          <Form>
            <Row>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="taxID">
                    Tax ID (หากไม่มีเลข Tax ID ให้ระบุเหตุผลว่า ไม่พบ,ต่างชาติ,บุคคล)
                  </Label>
                  {/* <FormControlLabel
                    control={
                      <Checkbox
                        // checked={this.state.checkedA}
                        // onChange={this.handleChange('checkedA')}
                        value="checkedA"
                      />
          }
          label="Secondary"
        /> */}
                  <Input
                    type="text"
                    id="taxid"
                    name="tax_id"
                    value={this.state.tmp_contact.tax_id}
                    onChange={this.handleChangeInputSec}
                    required
                  />
                  {/* <Button 
                  className="text-right"  
                  onClick={this.addCus}
                  color="success"
                  style={{ color: "white" }}
                >
                  <Icon className="pt-1">save</Icon> ตรวจสอบ{" "}
                </Button>{" "} */}
                  {/* <Input value={state.taxid} onChange={this.handleInput} type="text" name="taxid" id="taxid" required /> */}
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="account_no">CS</Label>
                  <Input
                    type="text"
                    id="account_no"
                    name="account_no"
                    value={this.state.tmp_contact.account_no}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="status">สถานะ</Label>
                  <br />
                  <Select
                    fullWidth
                    MenuProps={{
                      className: classes.selectMenu
                    }}
                    classes={{
                      select: classes.select
                    }}
                    value={this.state.tmp_contact.status}
                    onChange={this.handleChangeStatus}
                    onOpen={this.handleChangeStatus}
                    inputProps={{
                      name: "status",
                      id: "status"
                    }}
                  >
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value="0"
                      onClick={this.toggleChangeStatus}
                    >
                      0 - ยังไม่มีการติดต่อ
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value="1.1"
                      onClick={this.toggleChangeStatus}
                    >
                      1.1 - ยังไม่สนใจ
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value="1.2"
                      onClick={this.toggleChangeStatus}
                    >
                      1.2 - Call Center ติดตาม
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value="1.3"
                      onClick={this.toggleChangeStatus}
                    >
                      1.3 - ส่งข้อมูล
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value="1.4"
                      onClick={this.toggleChangeStatus}
                    >
                      1.4 - ลูกค้าให้เข้าพบ
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value="2"
                      onClick={this.toggleChangeStatus}
                    >
                      2 - เข้าพบลูกค้าแล้ว
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value="3"
                      onClick={this.toggleChangeStatus}
                    >
                      3 - เสนอราคา
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value="4"
                      onClick={this.toggleChangeStatus}
                    >
                      4 - ลูกค้าซื้อ
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value="5"
                      onClick={this.toggleChangeStatus}
                    >
                      5 - ข้อมูลซื้อซ้ำ
                    </MenuItem>
                  </Select>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="6" md="6" lg="6">
                <FormGroup>
                  <Label for="thaiName">ชื่อภาษาไทย</Label>
                  <Input
                    type="text"
                    id="thaiName"
                    name="company_thname"
                    value={this.state.tmp_contact.company_thname}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" md="6" lg="6">
                <FormGroup>
                  <Label for="engName">ชื่อภาษาอังกฤษ</Label>
                  <Input
                    type="text"
                    id="engName"
                    name="company_enname"
                    value={this.state.tmp_contact.company_enname}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="groupNameth">กลุ่มของบริษัท (ชื่อภาษาไทย)</Label>
                  <Input
                    type="text"
                    id="groupNameth"
                    name="group_thname"
                    value={this.state.tmp_contact.group_thname}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="groupNameen">
                    กลุ่มของบริษัท (ชื่อภาษาอังกฤษ)
                  </Label>
                  <Input
                    type="text"
                    id="groupNameen"
                    name="group_enname"
                    value={this.state.tmp_contact.group_enname}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="parent">Parent</Label>
                  <Input
                    type="text"
                    id="parent"
                    name="parent_account"
                    value={this.state.tmp_contact.parent_account}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="3" md="3" lg="3">
                <FormGroup>
                  <Label for="address">ที่อยู่</Label>
                  <Input
                    type="text"
                    id="address"
                    name="address_no"
                    value={this.state.tmp_contact.address_no}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="3" md="3" lg="3">
                <FormGroup>
                  <Label for="village">หมู่บ้าน</Label>
                  <Input
                    type="text"
                    name="vilage"
                    value={this.state.tmp_contact.vilage}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="3" md="3" lg="3">
                <FormGroup>
                  <Label for="villageNo">หมู่</Label>
                  <Input
                    type="text"
                    name="moo"
                    value={this.state.tmp_contact.moo}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="3" md="3" lg="3">
                <FormGroup>
                  <Label for="Lane">ซอย</Label>
                  <Input
                    type="text"
                    name="soi"
                    value={this.state.tmp_contact.soi}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="street">ถนน</Label>
                  <Input
                    type="text"
                    name="road"
                    value={this.state.tmp_contact.road}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="district">เขต/อำเภอ</Label>
                  <Input
                    type="text"
                    name="district"
                    value={this.state.tmp_contact.district}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="subdistrict">แขวง/ตำบล</Label>
                  <Input
                    type="text"
                    name="subdistrict"
                    value={this.state.tmp_contact.subdistrict}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="6" md="6" lg="6">
                <FormGroup>
                  <Label for="provice">จังหวัด</Label>
                  <Input
                    type="text"
                    name="province"
                    value={this.state.tmp_contact.province}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" md="6" lg="6">
                <FormGroup>
                  <Label for="postalCode">รหัสไปรษณีย์</Label>
                  <Input
                    type="text"
                    name="zipcode"
                    value={this.state.tmp_contact.zipcode}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
            </Row>
            <div className="text-right">
              {/* <Button
              onClick={()=>getStepContent(1, state, classes)}
              color="warning"
              style={{ color: "white", padding: "10px" }}
            >
              <Icon className="pt-1">forward</Icon> ถัด{" "}
            </Button>{" "} */}
            </div>
          </Form>
        );
      case 1:
        return (
          <Form>
            <Row>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="contact">Contact Name</Label>
                  <Input
                    type="text"
                    name="contact_name"
                    value={this.state.tmp_contact.contact_name}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="tel">Phone No.</Label>
                  <Input
                    type="text"
                    name="contact_no"
                    value={this.state.tmp_contact.contact_no}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="email">Email</Label>
                  <Input
                    type="text"
                    name="contact_email"
                    value={this.state.tmp_contact.contact_email}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="type">Type</Label>
                  <Input
                    type="text"
                    name="type"
                    value={this.state.tmp_contact.type}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="cusProduct">Customer Product</Label>
                  <Input
                    type="text"
                    name="customer_product"
                    value={this.state.tmp_contact.customer_product}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" md="4" lg="4" />
            </Row>
            <Row>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="contact2">Contact Name 2</Label>
                  <Input
                    type="text"
                    name="contact_name_2"
                    value={this.state.tmp_contact.contact_name_2}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="tel2">Phone No. 2</Label>
                  <Input
                    type="text"
                    name="contact_no_2"
                    value={this.state.tmp_contact.contact_no_2}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="email2">Email 2</Label>
                  <Input
                    type="text"
                    name="contact_email_2"
                    value={this.state.tmp_contact.contact_email_2}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="type2">Type</Label>
                  <Input
                    type="text"
                    name="type_2"
                    value={this.state.tmp_contact.type_2}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="cusProduct">Customer Product</Label>
                  <Input
                    type="text"
                    name="customer_product_2"
                    value={this.state.tmp_contact.customer_product_2}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" md="4" lg="4">
                <FormGroup>
                  <Label for="grade">Grade</Label>
                  <Input
                    type="text"
                    name="grade"
                    value={this.state.tmp_contact.grade}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
            </Row>
            <div className="text-right">
              {/* <Button
              color="warning"
              style={{ color: "white", padding: "10px" }}
            >
              <Icon className="pt-1">forward</Icon> ถัด{" "}
            </Button>{" "} */}
            </div>
          </Form>
        );
      case 2:
        return (
          <Form>
            <Row>
              <Col xs="12" sm="6" md="6" lg="6">
                <FormGroup
                  className="mt-3"
                  style={{
                    display:
                      this.state.user.acstatus === "4" ||
                      this.state.user.acstatus === "1"
                        ? "inline"
                        : "none"
                  }}
                >
                  <Label for="telSale">Sale name</Label>
                  <Input
                    disabled
                    value={this.state.selectsale}
                    type="text"
                    name="salename"
                    id="salename"
                  />
                </FormGroup>

                <FormGroup className="mt-3">
                  <FormControl fullWidth className={styles.formControl}>
                    <InputLabel
                      style={{
                        display:
                          this.state.user.acstatus !== "4" &&
                          this.state.user.acstatus !== "1"
                            ? "inline"
                            : "none"
                      }}
                      htmlFor="demo-controlled-open-select"
                    >
                      Sale name
                    </InputLabel>

                    <Select
                      style={{
                        display:
                          this.state.user.acstatus !== "4" &&
                          this.state.user.acstatus !== "1"
                            ? "inline"
                            : "none"
                      }}
                      value={this.state.selectsale}
                      onChange={this.handleSalename}
                      inputProps={{
                        name: "selectsale",
                        id: "selectsale"
                      }}
                    >
                      <MenuItem key={-1} value={""}>
                        {"ไม่มี Sale"}
                      </MenuItem>
                      {this.state.sales}
                    </Select>
                  </FormControl>
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" md="6" lg="6">
                <FormGroup>
                  <Label for="telSale">Phone No. (Sales)</Label>
                  <Input
                    type="text"
                    name="telSale"
                    value={this.state.tel}
                    id="telSale"
                    disabled
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="6" md="6" lg="6">
                <FormGroup>
                  <Label for="emailSale">Email (Sales)</Label>
                  <Input
                    type="text"
                    value={this.state.emailSale}
                    name="emailSale"
                    id="emailSale"
                    disabled
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" md="6" lg="6">
                <FormGroup className="mt-3">
                  <FormControl fullWidth className={styles.formControl}>
                    <InputLabel htmlFor="demo-controlled-open-select">
                      Call Center Name
                    </InputLabel>
                    <Select
                      value={this.state.selectCallcenter}
                      onChange={this.handleCallcentername}
                      inputProps={{
                        name: "selectCallcenter",
                        id: "selectCallcenter"
                      }}
                    >
                      <MenuItem key={-1} value={""}>
                        {"ไม่มี Call Center"}
                      </MenuItem>
                      {this.state.callcenter}
                    </Select>
                  </FormControl>
                </FormGroup>
              </Col>
            </Row>
            <div className="text-right">
              {/* <Button
              color="warning"
              style={{ color: "white", padding: "10px" }}
            >
              <Icon className="pt-1">forward</Icon> ถัด{" "}
            </Button>{" "} */}
            </div>
          </Form>
        );

      case 3:
        return (
          <Form>
            <h6>4. ข้อมูลทางบัญชี</h6>
            <Row>
            <Col xs="12" sm="2" md="2" lg="2">
                <FormGroup>
                  <Label for="saleName">Financial Code</Label>
                  <Input
                    type="text"
                    name="financial_code"
                    value={this.state.tmp_contact.financial_code}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="2" md="2" lg="2">
                <FormGroup>
                  <Label for="saleName">Financial Grade</Label>
                  <Input
                    type="text"
                    name="financial_grade"
                    value={this.state.tmp_contact.financial_grade}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
             
              <Col xs="12" sm="4" md="4" lg="4">
                <FormGroup>
                  <Label for="telSale">Billing Name</Label>
                  <Input
                    type="text"
                    name="billing_name"
                    value={this.state.tmp_contact.billing_name}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="4" md="4" lg="4">
                <FormGroup>
                  <Label for="telSale">Billing Place</Label>
                  <Input
                    type="text"
                    name="billing_place"
                    value={this.state.tmp_contact.billing_place}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="4" md="4" lg="4">
                <FormGroup>
                  <Label for="receiveDate">Cheque Receive Date</Label>
                  <Input
                    type="date"
                    name="cheque_receive_date"
                    value={this.state.tmp_contact.cheque_receive_date}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="4" md="4" lg="4">
                <FormGroup>
                  <Label for="createDate">Bill Create Date</Label>
                  <Input
                    type="date"
                    name="bill_create_date"
                    value={this.state.tmp_contact.bill_create_date}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="4" md="4" lg="4">
                <FormGroup>
                  <Label for="officerName">Finance Officer Name</Label>
                  <Input
                    type="text"
                    name="financial_contact_name"
                    value={this.state.tmp_contact.financial_contact_name}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="6" md="6" lg="6">
                <FormGroup>
                  <Label for="tel">Phone No.</Label>
                  <Input
                    type="text"
                    name="financial_contact_phone"
                    value={this.state.tmp_contact.financial_contact_phone}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
              <Col xs="12" sm="6" md="6" lg="6">
                <FormGroup>
                  <Label for="email">Email</Label>
                  <Input
                    type="text"
                    name="financial_contact_email"
                    value={this.state.tmp_contact.financial_contact_email}
                    onChange={this.handleChangeInputSec}
                  />
                </FormGroup>
              </Col>
            </Row>
            {/* <div className="text-right">
            <Button
              color="success"
              style={{ color: "white", padding: "10px" }}
            >
              <Icon className="pt-1">save</Icon> บันทึก{" "}
            </Button>{" "}
          </div> */}
          </Form>
        );
      default:
        return "Unknown stepIndex";
    }
  }

   getSales() {
    let user =  JSON.parse(localStorage.getItem("data"));
     axios
      .get(conf.url + "/sale", {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        //console.log(res);
        let sales = res.data.data.map((data, index) => {
          return (
            <MenuItem
              tel={data.actelephone}
              key={index}
              value={data.acusername}
            >
              {data.acfirstname + " " + data.aclastname}
            </MenuItem>
          );
        });
        this.setState({
          sales: sales,
          salesData: res.data.data
        });
      })
      .then(() => {
        if (user.acstatus === "4") {
          this.setState({
            user: user,
            selectsale: user.acusername
          });
          this.state.salesData.map(data => {
            if (data.acusername === this.state.selectsale)
              this.setState({
                tel: data.actelephone,
                emailSale: data.acemail,
                sale_name: data.acfirstname + " " + data.aclastname
              });
          });
        } else {
          this.setState({
            user: user
          });
        }
      });
  }
  getCallCenters() {
    axios
      .get(conf.url + "/callcenter", {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        //console.log(res);
        let callcenter = res.data.data.map((data, index) => {
          return (
            <MenuItem
              tel={data.actelephone}
              key={index}
              value={data.acusername}
            >
              {data.acfirstname + " " + data.aclastname}
            </MenuItem>
          );
        });
        this.setState({
          callcenter: callcenter,
          tmp_callcenter: res.data.data
        });
      });
  }
  handleInput = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  handleSalename = event => {
    this.setState({ [event.target.name]: event.target.value });
    if (event.target.value !== "") {
      this.state.salesData.map(data => {
        if (data.acusername === event.target.value)
          this.setState({
            tel: data.actelephone,
            emailSale: data.acemail,
            sale_name: data.acfirstname + " " + data.aclastname
          });
      });
    } else {
      this.setState({
        tel: "",
        emailSale: ""
      });
    }
  };

  handleCallcentername = event => {
    let tmpCall = this.state.tmp_contact;
    this.state.tmp_callcenter.map(data=>{
      
      if(event.target.value === data.acusername){
        console.log(data)
         tmpCall.call_center_name = data.acfirstname + " " + data.aclastname;
         console.log( tmpCall.call_center_name )
      }
    })
   
    this.setState({ 
      [event.target.name]: event.target.value ,
      tmp_contact:tmpCall
    });
  };

  handleStep = step => () => {
    this.setState({
      activeStep: step
    });
  };

  handleNext = () => {
    this.setState(state => ({
      activeStep: state.activeStep + 1
    }));
  };

  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1
    }));
  };

  handleReset = () => {
    this.setState({
      activeStep: 0
    });
  };

  addCus() {
    this.setState({
      Loading: true
    })
    //console.log(this.state.tmp_contact);
    if (
      this.state.tmp_contact.company_thname.length !== 0 &&
      this.state.tmp_contact.tax_id.length !== 0
    ) {
      const params = {
        token: localStorage.getItem("token"),
        data: this.state.tmp_contact,
        sale_name: this.state.sale_name,
        sale_id: this.state.selectsale,
        sale_phone: this.state.tel,
        sale_email: this.state.emailSale
      };
      axios
        .post(conf.url + "/contact", JSON.stringify(params), {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          if (res.data.msg !== undefined) {
            if (res.data.msg === "edit suc") {
              var r = window.confirm("เนื่องจากมีลูกค้ารายนี้อยู่ ระบบจะทำการนำข้อมูลใหม่บันทึกลง!");
              if (r == true) {
                axios
                .post(conf.url + "/contact/update", JSON.stringify(params), {
                  headers: {
                    "Content-Type": "application/json"
                  }
                })
                .then(res=>{
                  window.location.assign("/tables");
                })
              }
            } else {
              alert("บันทึกข้อมูลสำเร็จ!");
              window.location.assign("/tables");
            }
          }

          this.setState({
            Loading: false
          });
        })
        .catch(er => {
          this.setState({
            Loading: false
          });
        });
    } else {
      alert("กรุณากรอก Tax ID และ ชื่อบริษัทภาษาไทย");
    }
  }

  render() {
    const { classes } = this.props;
    const steps = getSteps();
    const { activeStep } = this.state;
    const connector = (
      <StepConnector
        classes={{
          active: classes.connectorActive,
          completed: classes.connectorCompleted,
          disabled: classes.connectorDisabled,
          line: classes.connectorLine
        }}
      />
    );
    return (
      <div
        style={{
          padding: "15px",
          border: "1px solid #333B51",
          borderRadius: "8px"
        }}
      >
        <Stepper activeStep={activeStep} nonLinear connector={connector}>
          {steps.map((label, index) => (
            <Step key={label}>
              <StepButton onClick={this.handleStep(index)}>{label}</StepButton>
            </Step>
          ))}
        </Stepper>
        <div>
          {this.state.activeStep === steps.length ? (
            <div>
              <Typography className={classes.instructions}>
                All steps completed
              </Typography>
              <Button onClick={this.handleReset}>Reset</Button>
            </div>
          ) : (
            <div>
              <Typography className={classes.instructions}>
                {this.getStepContent(activeStep, this.state, this.props)}
              </Typography>
              <div className="text-right">
                <Button
                  onClick={()=>{
                    window.location.assign("/tables");
                  }}
                  color="danger"
                  style={{ color: "white", padding: "10px" }}
                >
                  <Icon className="pt-1">save</Icon> ยกเลิก{" "}
                </Button>{" "}
                <Button
                disabled={this.state.Loading}
                  onClick={this.addCus}
                  color="success"
                  style={{ color: "white", padding: "10px" }}
                >
                  <Icon className="pt-1">save</Icon> บันทึก{" "}
                </Button>{" "}
              </div>
              {/* <div >
                          <Button
                            disabled={activeStep === 0}
                            onClick={this.handleBack}
                            className={classes.backButton}
                          >
                            Back
                          </Button>
                          <Button variant="contained" color="primary" onClick={this.handleNext}>
                            {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                          </Button>
                        </div> */}
            </div>
          )}
        </div>
      </div>
    );
  }
}

AddCustomer.propTypes = {
  classes: PropTypes.object
};

export default withStyles(styles)(AddCustomer);



// WEBPACK FOOTER //
// ./src/views/Addcustomer/Addcustomer.jsx